import { FlowType } from '#src/utils/types';
import { useFlow } from '@edreamsodigeo/frontend-core';

type StyleMap<Type> = {
  [key in FlowType]: Type;
};

export const getStylePerFlow = <Type>(map: StyleMap<Type>, flow: FlowType) => {
  return map[flow];
};

export const useStylePerFlow = () => {
  const flow = useFlow();
  return <Type>(map: StyleMap<Type>) => getStylePerFlow(map, flow);
};
